export const ASSIGNMENTS_LOAD_REQUEST = 'ASSIGNMENTS_LOAD_REQUEST';
export const ASSIGNMENTS_LOAD_REQUEST_V3 = 'ASSIGNMENTS_LOAD_REQUEST_V3';
export const ASSIGNMENTS_LOAD_SUCCESS = 'ASSIGNMENTS_LOAD_SUCCESS';
export const ASSIGNMENTS_LOAD_SUCCESS_V3 = 'ASSIGNMENTS_LOAD_SUCCESS_V3';
export const ASSIGNMENTS_LOAD_FAILURE = 'ASSIGNMENTS_LOAD_FAILURE';
export const START_ASSIGNMENTS_POLLING = 'START_ASSIGNMENTS_POLLING';
export const INITIAL_ASSIGNMENT_LOADING_REQUEST = 'INITIAL_ASSIGNMENT_LOADING_REQUEST';
